import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import StatusCardTicket from '../../status-card-ticket/StatusCard';

class HistoryTicketModal extends React.Component {
    render() {
        const { show, statusList, onClose } = this.props;

        return (
            <Modal size='xl' show={show} onHide={onClose}>
                <Modal.Header closeButton>
                <Modal.Title>Storico Stati</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <fieldset className='d-flex status-history-body'>
              <legend className="detail-legend">Lista Stati</legend>
              <div className='d-flex flex-column'>
                {statusList.map((status, index) => {
                    return <StatusCardTicket key={index} status={status} showDescription={true}/>
                })}
              </div>
              {statusList.length === 0 && <span>Non ci sono stati</span>}
            </fieldset>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Chiudi
                </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default HistoryTicketModal
